<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back" @click="goBack">
          {{ lang === "cn" ? "返回" : "Back" }}
        </div>
        <div class="header-wrap">
          <div class="header_box">
            <div style="width: 100%">
              <div class="main-title">
                {{ lang === "cn" ? "产品管理" : "Product Management" }}
              </div>
            </div>
            <div class="right_box">
              <div class="create-btn" @click="toLink('/newProduct')">
                {{ lang === "cn" ? "创建产品" : "Create" }}
              </div>
            </div>
          </div>

          <!-- 搜索 -->
          <div class="search-wrap">
            <div class="search-input">
              <!-- <p>{{ lang === 'cn' ? "本届参展商" : "This session's exhibitor" }}</p> -->
              <el-input
                v-model="keywords"
                :placeholder="
                  lang === 'cn'
                    ? '请输入产品名称'
                    : 'Please enter the product name'
                "
              ></el-input>
            </div>
            <div class="search-input search-btn-wrap">
              <div class="search-btn" @click="search">
                {{ lang === "cn" ? "搜索" : "Search" }}
              </div>
            </div>
          </div>
        </div>
        <!-- 新列表 -->
        <div class="tips-wrap">
          <!-- <div class="sort-tips">
            {{ lang === 'cn' ? "如需设置店铺产品顺序，请在排序栏修改数字，大数靠前" : "To set the product order, please modify the numbers in the sort column. The higher the number, the earlier the product will appear." }}
          </div> -->
          <div class="p-tips">
            {{ lang === "cn" ? "共有" : "There are " }}
            <span>{{ totals }}</span>
            {{ lang === "cn" ? "个产品" : "products in total" }}
          </div>
        </div>
        <div class="p_list" v-loading.lock="loading">
          <template>
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              :empty-text="lang === 'cn' ? '暂无数据' : 'No Records Found'"
              @selection-change="handleSelectionChange"
            >
              <!-- 加上type = "selection" -->
              <el-table-column width="55" fixed="left"> </el-table-column>
              <el-table-column
                label="ID"
                prop="id"
                width="150"
              ></el-table-column>
              <el-table-column
                :prop="tableDataProp.product_name"
                :label="lang === 'cn' ? '产品名称' : 'Product name'"
                width="400"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                :prop="tableDataProp.product_category"
                :label="lang === 'cn' ? '产品类别' : 'Product category'"
                width="400"
              ></el-table-column>
              <el-table-column
                :label="lang === 'cn' ? '上架' : 'Listed (Yes/No)'"
                min-width="140"
              >
                <template slot-scope="scope">
                  <el-switch
                    :value="scope.row.is_show == '1' ? true : false"
                    active-color="#409EFF"
                    inactive-color="#DCDFE6"
                    @change="storeMainHandle(scope.$index, scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <!-- <el-table-column :label="lang === 'cn' ? '置顶' : 'Pinned (Yes/No)'" min-width="60">
                <template slot-scope="scope">
                  <el-switch
                    :value="scope.row.ontop === '是' ? true : false"
                    active-color="#409EFF"
                    inactive-color="#DCDFE6"
                    disabled
                  >
                  </el-switch>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="审核状态" min-width="80">
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.examine == "1"
                        ? "待审核"
                        : scope.row.examine == "2"
                        ? "已审核"
                        : "未通过"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="公司名称"
                min-width="100"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="contacts"
                label="联系人"
                min-width="80"
              ></el-table-column>
              <el-table-column label="排序" width="80">
                <template slot-scope="scope">
                  <el-input
                    class="sort-input"
                    type="number"
                    v-model="scope.row.store_sort"
                    placeholder="0"
                    @change="sortHandle(scope.row)"
                  ></el-input>
                </template>
              </el-table-column> -->
              <el-table-column
                :label="lang === 'cn' ? '操作' : 'actions'"
                min-width="160"
                fixed="right"
              >
                <template slot-scope="scope">
                  <span class="check-btn" @click="toInquiryList(scope.row)">{{
                    lang === "cn" ? "询盘列表" : "Inquiry list"
                  }}</span>
                  |
                  <span class="check-btn" @click="edit(scope.row)">{{
                    lang === "cn" ? "编辑" : "edit"
                  }}</span>
                  |
                  <span
                    class="check-btn check-del"
                    @click="del(scope.$index, scope.row)"
                    >{{ lang === "cn" ? "删除" : "delete" }}</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="pagination_box">
          <!-- <div class="pagination_left">
            <div class="pagination_btn" @click="delMore">删除</div>
            <div class="pagination_btn" @click="upDownHandle(1)">批量上架</div>
            <div class="pagination_btn" @click="upDownHandle(0)">批量下架</div>
          </div> -->
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="pagesize"
            layout="prev, pager, next"
            :total="totals"
            v-if="totals != 0"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  productList,
  delproduct,
  upDown,
  storeNew,
  storeMain,
  setSort,
  upAndDownShelves,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "productList",
  data() {
    return {
      lang: localStorage.getItem("language"),
      keywords: "",
      loading: false,
      active: -1,
      totals: "",
      tableData: [],
      page: 1,
      pagesize: 10,
      mark: "",
      detail: {},
      tableDataProp: {
        product_name: "",
        product_category: "",
      },
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/conference" && item.id == 32;
    });
    this.detail = stepMenuList[index].children[0];
    this.active = index;
    // 获取产品分类
    // this.getType();
    // this.page = 1;
    // 24.8.28 当前页码在存储拿到
    this.page = Number(sessionStorage.getItem("currentProductPage")) || 1;
    this.mark = this.$route.query.mark;
    // 获取列表
    this.getList(this.page, this.searchs);
  },
  created() {
    if (this.lang === "cn") {
      this.tableDataProp.product_name = "product_name";
      this.tableDataProp.product_category =
        "category_name_cn_en[category_name]";
    } else if (this.lang === "en") {
      this.tableDataProp.product_name = "en_product_name";
      this.tableDataProp.product_category =
        "category_name_cn_en[en_category_name]";
    }
  },
  methods: {
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //搜索
    search() {
      this.page = 1;
      this.getList(this.page);
    },
    //获取列表
    getList(page) {
      let data;
      if (this.lang === "cn") {
        data = this.$qs.stringify({
          page_size: this.pagesize,
          page_no: page,
          product_name: this.keywords,
        });
      } else if (this.lang === "en") {
        data = this.$qs.stringify({
          page_size: this.pagesize,
          page_no: page,
          en_product_name: this.keywords,
        });
      }
      this.loading = true;
      productList(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.loading = false;
            let { data } = res.data;
            let arr = data.lists;
            arr.forEach((item) => {
              item.store_main = item.store_main == 0 ? false : true;
              item.store_new = item.store_new == 0 ? false : true;
            });
            this.tableData = arr;
            this.totals = data.count;
          } else {
            this.$message.warning(res.data.data);
          }
        })
        .catch((err) => {
          if (err.response.data.code != 401) {
            this.$message.warning(err.response.data.data);
          }
        });
    },
    // 跳转询盘列表
    toInquiryList(row) {
      this.$router.push({
        path: "/inquiryList",
        query: { id: row.product_long_id },
      });
    },
    // 跳转页面
    toLink(path) {
      this.$router.push({
        path,
      });
      // this.$alert(`请确保填写信息的真实性并符合相关法律规定!`, "", {
      //   confirmButtonText: "确定",
      //   callback: (action) => {
      //     if (action == "confirm") {
      //       this.$router.push({
      //         path,
      //       });
      //     }
      //   },
      // });
    },
    //24.9.1 排序 dxm
    sortHandle(scope) {
      setSort({
        product_long_id: scope.product_long_id,
        store_sort: scope.store_sort,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.page = 1;
            this.getList(this.page, this.searchs);
          }
        })
        .catch((err) => {
          console.log(err, "===err");
        });
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/conference",
        query: {
          id: 32,
        },
      });
    },
    // 编辑
    edit(row) {
      // let mark = this.mark;
      // this.$router.push({
      //   path: "/createProduct",
      //   query: {
      //     id: row.product_long_id,
      //     mark,
      //   },
      // });
      this.$router.push({
        path: "/newProduct",
        query: {
          id: row.product_long_id,
        },
      });
    }, // 删除
    del(index, row) {
      let obj = {};
      if (this.lang === "cn") {
        obj.tips = "确定要删除吗？";
        obj.confirm = "确定";
      } else {
        obj.tips = "Confirm deletion?";
        obj.confirm = "Confirm";
      }
      this.$alert(obj.tips, "", {
        confirmButtonText: obj.confirm,
        callback: (action) => {
          if (action == "confirm") {
            delproduct({ product_long_id: row.product_long_id })
              .then((res) => {
                if (res.data.code == 1) {
                  this.tableData.splice(index, 1);
                  this.totals = this.totals - 1;
                  this.$message.success(
                    this.lang === "cn" ? "删除成功" : "Deleted Successfully"
                  );
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    //
    delMore() {
      let selectData = this.multipleSelection;
      if (!selectData) {
        this.$message.warning("请至少选择一项");
        return false;
      }
      let select = [];
      selectData.forEach((item) => {
        select.push(item.product_long_id);
      });
      select = select.join(",");
      this.$alert(`确定要删除吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            delproduct({ product_long_id: select })
              .then((res) => {
                if (res.data.code == 1) {
                  this.page = 1;
                  this.getList(this.page);
                  this.$message.success("删除成功");
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    //批量上下架
    upDownHandle(type) {
      let selectData = this.multipleSelection;
      if (!selectData) {
        this.$message.warning("请至少选择一项");
        return false;
      }
      let select = [];
      selectData.forEach((item) => {
        select.push(item.product_long_id);
      });
      select = select.join(",");
      this.$alert(`确定要${type == 0 ? "下架" : "上架"}吗？`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            upDown({ product_long_id: select, status: type })
              .then((res) => {
                if (res.data.code == 1) {
                  this.page = 1;
                  this.getList(this.page);
                  this.$message.success(res.data.msg);
                }
              })
              .catch((err) => {
                console.log(err, "===err");
              });
          }
        },
      });
    },
    //修改主推状态
    async storeMainHandle(index, row) {
      this.loading = true;
      let data = {
        product_long_id: row.product_long_id,
        is_show: row.is_show == "0" ? "1" : "0",
        mark: this.mark,
      };
      const res = await upAndDownShelves(data);
      if (res.data.code == 1) {
        this.tableData[index].is_show = row.is_show == "0" ? "1" : "0";
      }
      this.loading = false;
      // storeMain({
      //   product_long_id: row.product_long_id,
      //   store_main: row.store_main ? 0 : 1,
      // })
      //   .then((res) => {
      //     if (res.data.code == 1) {
      //       this.tableData[index].store_main =
      //         !this.tableData[index].store_main;
      //       this.$message.success(res.data.msg);
      //       this.page = 1;
      //       this.getList(this.page, this.searchs);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err, "===err");
      //   });
    },
    //修改新品状态
    storeNewHandle(index, row) {
      storeNew({
        product_long_id: row.product_long_id,
        store_new: row.store_new ? 0 : 1,
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.tableData[index].store_new = !this.tableData[index].store_new;
            this.$message.success(res.data.msg);
            this.page = 1;
            this.getList(this.page, this.searchs);
          }
        })
        .catch((err) => {
          console.log(err, "===err");
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      sessionStorage.setItem("currentProductPage", this.page);
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  border-radius: 10px;
}
/deep/ .el-table__body-wrapper {
  min-height: 400px;
}
/deep/ .sort-input .el-input__inner {
  text-align: center;
  padding: 0 0 0 15px;
}
.content {
  margin-bottom: 0;
}
.times {
  width: 300px;
  color: red;
}
.right_box {
  display: flex;
  align-items: center;
}
.txt_box {
  margin-top: 25px;
  color: red;
}
.list {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-sizing: border-box;
}
.search_item {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  span {
    display: inline-block;
    width: 200px;
    text-align: right;
  }
}
.pagination_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
  /deep/ .el-pagination {
    width: 100%;
    text-align: right;
  }
  .pagination_left {
    display: flex;
    .pagination_btn {
      color: #fff;
      height: 32px;
      font-size: 14px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 4px;
      background: #3d83e9;
      margin-right: 10px;
    }
  }
}
.goods_name {
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.tname {
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-top: 15px;
}
.inputtime {
  font-size: 12px;
  font-weight: 400;
  color: #969696;
  margin-top: 10px;
  line-height: 18px;
}
.p_footer {
  display: flex;

  .p_item_footer {
    width: 50%;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .p_item_footer:nth-child(1) {
    border-right: 2px solid #eee;
  }
}
.header-wrap {
  padding: 20px;
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
  position: relative;
}
.header_box {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.create-btn {
  width: 103px;
  height: 36px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  border-radius: 4px;
  background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
}
.content-type {
  padding-bottom: 35px;
  .main-title {
    width: 100%;
    margin-top: 40px;
  }
}
.tips-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  .p-tips {
    color: #333;
    span {
      color: #0091ff;
      font-weight: bold;
    }
  }
  .sort-tips {
    color: red;
    font-size: 14px;
  }
}

.p_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
}
.p_item {
  width: -webkit-calc((100% - 20px * 4)/ 4);
  width: calc((100% - 20px * 4) / 4);
  margin: 0 20px 20px 0;
  background: #fff;
  border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item_top {
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select_box {
    width: 80px;
  }
}
.p_item_scoend {
  margin-top: 10px;
  padding: 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #eee;
  img {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-right: 20px;
  }
}
.search-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  background: #fff;
  // padding: 20px;
  margin: 20px 0;
  border-radius: 10px;
  .search-input {
    width: 30%;
    font-size: 14px;
    color: #7f8fa4;
    line-height: 22px;
    margin-right: 24px;
    p {
      margin-bottom: 7px;
    }
    .search-btn {
      width: 103px;
      height: 38px;
      color: #fff;
      font-size: 14px;
      line-height: 38px;
      text-align: center;
      background: #fc933f;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
.invitation-table {
  margin-top: 0 !important;
  padding-top: 0 !important;
  border-top: 0 none !important;
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
    .header_box {
      margin-top: 10px;
    }
  }
  .search-wrap {
    .search-input {
      width: 100%;
    }
  }
  .pagination_box {
    flex-wrap: wrap;
    .el-pagination {
      width: 100%;
      text-align: right;
      padding: 20px 0 !important;
    }
  }
}
</style>
<style lang="scss">
.invitation-table .el-pagination {
  margin-top: 30px;
  text-align: center;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.my-table {
  color: #888;
  font-size: 18px;
  margin-top: 30px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.check-btn {
  color: #3d83e9;
  cursor: pointer;
}
.check-btn:hover {
  text-decoration: underline;
}
.check-del {
  color: #ff4d4f;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.my-table tbody tr td .check-btn:hover {
  text-decoration: underline;
}
.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
@media only screen and (max-width: 1366px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 20px * 3)/ 3) !important;
    width: calc((100% - 20px * 3) / 3) !important;
    margin: 0 20px 20px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1280px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1200px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    //   margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
</style>
<style>
@media only screen and (max-width: 767px) {
  .el-pagination {
    padding: 2px 23px !important;
  }
  .el-message-box {
    width: 350px !important;
  }
}
</style>